// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_a12","cls2":"Comments-cls2_mYj Comments-cls1_a12"};